// Various image js 
function VariousImage() {
    function getFileName(src) {
        return src
            .split('/')
            .pop()
            .split('?')[0]
            .toLowerCase();
    }

    function filterImagesByVariant(colorValue, productWrapper) {
        if (!colorValue || !productWrapper) return;

        const value = colorValue.toLowerCase();
        const slides = document.querySelectorAll('.various_img .bz_product_media');

        slides.forEach(slide => {
            const img = slide.querySelector('img');
            if (!img) return;

            const fileName = getFileName(img.src);
            const hasAnyColor = fileName.match(/_([a-z]+)\.(webp|jpg|jpeg|png|avif)$/);
            if (!hasAnyColor) return;

            const imageColor = hasAnyColor[1];
            const parentIsSlider = slide.closest('bz-slider') !== null;

            slide.classList.add('hidden');

            if (imageColor === value) {
                slide.classList.remove('hidden');
                if (parentIsSlider) slide.classList.add('swiper-slide');
            } else {
                if (parentIsSlider) slide.classList.remove('swiper-slide');
            }
        });

        productWrapper.querySelectorAll('.bz_product_image .swiper').forEach(swiperEl => {
            if (swiperEl.swiper) {
                swiperEl.swiper.update();
                swiperEl.swiper.slideTo(0, 0);
            }
        });
    }
    document.body.addEventListener('change', function (e) {
        const target = e.target;
        if ((target.matches('input.input_radio') || target.matches('select')) && target.name.toLowerCase().includes('color')) {
            const productVariants = target.closest('.product_variants');
            const productWrapper = target.closest('.bz_product_details');
            if (productVariants && productWrapper) {
                filterImagesByVariant(target.value, productWrapper);
            }
        }
    });


    document.querySelectorAll('.product_variants').forEach(variantsEl => {
        const productWrapper = variantsEl.closest('.bz_product_details');
        if (!productWrapper) return;

        const checkedRadio = variantsEl.querySelector('input.input_radio[name*="Color"]:checked');
        if (checkedRadio) {
            filterImagesByVariant(checkedRadio.value, productWrapper);
            return;
        }

        const colorSelect = variantsEl.querySelector('select[name*="Color"], select[name*="color"]');
        if (colorSelect && colorSelect.value) {
            filterImagesByVariant(colorSelect.value, productWrapper);
        }
    });
}
['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder']
.forEach(e => addEventListener(e, VariousImage));